import { ZfWebComponentsConfig } from '@zafire/react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { AppWrapper } from './app/AppWrapper';
import { NAVIGATION_BAR_HEIGHT } from './app/config/constants';
import { registerAgGrid } from './app/config/setup-ag-grid';
import './app/i18n/i18nextInit';
import './styles/main.scss';

const AUTH_SILENT_REDIRECT_PATH = '/silent-renew.html';

registerAgGrid();

const root = createRoot(document.getElementById('root')!);
root.render(
    <AppWrapper
        totalNavbarHeight={NAVIGATION_BAR_HEIGHT}
        bodyElement={document.body}
        auth={{ silentRedirectPath: AUTH_SILENT_REDIRECT_PATH }}
        silentLogin={false}
    >
        <ZfWebComponentsConfig>
            <App />
        </ZfWebComponentsConfig>
    </AppWrapper>,
);
